import angular from 'angular';
import labelToggler from './labelToggler';

export default angular
  .module('components.labelToggler', [])
  .component('labelToggler', labelToggler).name;
